const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the scorm host ScormRegistrations component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {ScormRegistrations} ScormRegistrations the resource defined to manage ScormRegistrations
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('scormHostRegistrations', ['Application', 'Authorization', 'ScormRegistrations', 'Users', function(Application, Authorization, ScormRegistrations, Users) {
    return {
      restrict: 'E',
      replace: true,
      scope: {},
      template: require('../../templates/directives/scorm-host-registrations.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          var params = Application.navigation.getRouteParameters();

          self.translations = {};

          self.sortName = 'createdAt';
          self.sortOrder = -1;
          self.scormId = params.id;

          self.filter = {
            subresource: self.scormId,
            page: 1,
            limit: 20,
            sort: {'createdAt': -1}
          };

          self.goToUser = function(user) {
            if (!user || !user.id) {
              return;
            }
            Application.navigation.goTo('/edit/users/' + user.id);
          };

          self.goToContextLink = function(context) {
            let type = context.context_type.toLowerCase();
            if (type !== 'track') {
              type += 's';
            }
            return ('#/host/' + type + '/' + context.context._id);
          }

          self.editMenu = {
            visible: false,
            activeId: null,
            closeHandler: function(){
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            },
            clickHandler: function(i){
              if (self.editMenu.visible) {
                if (self.editMenu.activeId === i) {
                  self.editMenu.visible = false;
                  self.editMenu.activeId = null;
                } else {
                  self.editMenu.activeId = i;
                }
              } else {
                self.editMenu.activeId = i;
                self.editMenu.visible = true;
              }
            }
          };

          self.nextPage = function() {
            if (!self.filter.page) {
              self.filter.page = 0;
            }
            self.filter.page++;
            self.loadItems();
          };
          self.previousPage = function() {
            if (!self.filter.page || self.filter.page < 2) {
              self.filter.page = 2;
            }
            self.filter.page--;
            self.loadItems();
          };
          self.getLocation = function(user) {
            if (user && user.location_name) {
              return user.location_name;
            }
            return '-----';
          };
          self.getDepartment = function(user) {
            if (user && user.department_name) {
              return user.department_name;
            }
            return '-----';
          };

          self.manualCompletion = {
            current: null,
            show: false,
            select: function(registration) {
              self.manualCompletion.current = registration;
              self.manualCompletion.show = true;
            },
            postSubmit: function() {
              self.filter.page = 1;
              self.initialize();
            }
          };

          self.loadItems = function(noNext, empty) {
            self.searchLoading = true;
            if (empty) {
              self.allowNext = false;
              self.allowPrevious = true;
              self.searchLoading = false;
              self.registrations = []
              return;
            }
            ScormRegistrations.find(self.filter).$promise.then(function(items) {
              self.allowNext = noNext ? false : true;
              self.allowPrevious = true;
              if (items.length < self.filter.limit) {
                self.allowNext = false;

                if (!noNext && !items.length && self.filter.page > 1) {
                  self.filter.page--;
                  self.loadItems(true);
                  self.searchLoading = false;
                  return;
                }

              }

              if (self.filter.page < 2) {
                self.allowPrevious = false;
              }

              self.registrations = items;
              self.searchLoading = false;
            });
          };
          self.slimDate = function(date, yyyyMMddhhmmss) {
            if (yyyyMMddhhmmss) {
              moment(date, 'YYYYMMDDhhmmss').format('D-MMM-YYYY h:mm a');
            }
            return moment(new Date(date)).format('D-MMM-YYYY h:mm a');
          };
          self.timeSpent = function(seconds_spent) {
            var seconds = parseInt(seconds_spent, 10);

            var days = Math.floor(seconds / (3600 * 24));
            seconds -= days * 3600 * 24;
            var hrs = Math.floor(seconds / 3600);
            seconds -= hrs * 3600;
            var mnts = Math.floor(seconds / 60);
            seconds -= mnts * 60;
            if (days > 0) {
              return days + "d " + hrs + "h " + mnts + "m " + seconds + "s";
            }
            if (hrs > 0) {
              return hrs + "h " + mnts + "m " + seconds + "s";
            }
            if (mnts > 0) {
              return mnts + "m " + seconds + "s";
            }
            return seconds + "s";
          };
          self.changeSort = function(name) {
            self.filter.page = 0;
            if (self.sortName !== name) {
              self.sortOrder = -1;
            }
            if (self.sortName === name) {
              self.sortOrder = self.sortOrder * -1;
            }
            self.sortName = name;
            self.filter.sort = {};
            self.filter.sort[self.sortName] = self.sortOrder;
            self.nextPage();
          };
          self.initialize = function() {
            if (!self.scormId) {
              Application.navigation.goToHome();
              return;
            }
            self.registrations = [];
            self.loadItems();
            self.full_csv = Application.API + '/learn/v3/scorm/registrations/' + self.scormId + '/csv?authtoken=' + Authorization.getAuthToken().authtoken;

          };
          self.userDirectory = {};
          self.smart_filter = {};
          self.selectionDirectory = {};
          self.selections = {
            select: function(item) {
              var id = item._id;
              if (self.selectionDirectory[id]) {
                delete self.selectionDirectory[id];
              } else {
                self.selectionDirectory[id] = item;
              }

              var ids = [];
              for (var id in self.selectionDirectory) {
                ids.push(self.selectionDirectory[id]._id.toString());
              }
              self.searchItems.csv_selected += '&users=$in,' + ids.length + ',' + ids.join(',');
            },
            isChecked: function(item) {
              if (!item || !item._id) {
                return false;
              }
              return self.selectionDirectory[item._id] ? true : false;
            },
            clear: function() {
              self.selectionDirectory = {};
            }
          };
          self.searchItems = {
            placeholder: self.translations['scormHostRegistrations.search_placeholder'],
            onQuery: function(query_arguments) {
              self.smart_filter = {};
              self.searching = false;
              if (query_arguments && typeof query_arguments === 'object' && Object.keys(query_arguments).length) {
                self.searching = true;
              }
              if (!query_arguments || (typeof query_arguments === 'object' && Object.keys(query_arguments).length === 0)) {
                self.filter = {
                  subresource: self.scormId,
                  page: 1,
                  limit: 20,
                  'user-populate': 'first_name,last_name,email,image,linked_locations,linked_departments',
                  'user.linked_locations-populate': 'name',
                  'user.linked_departments-populate': 'name',
                  'content-populate': 'title,description,archived,createdAt',
                  fields: 'company,user,content,results,status,createdAt',
                  sort: {}
                };
                self.filter.sort[self.sortName] = self.sortOrder;
                self.loadItems();
                return;
              }

              for (var key in query_arguments) {
                self.smart_filter[key] = query_arguments[key];
              }
              var user_filter = {
                fields: '_id,first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
                'linked_locations-populate': 'name',
                'linked_departments-populate': 'name',
                page: 1,
                per_page: 50
              };
              if (self.smart_filter.privacy_locations) {
                user_filter.linked_locations = self.smart_filter.privacy_locations;
              }
              if (self.smart_filter.privacy_departments) {
                user_filter.linked_departments = self.smart_filter.privacy_departments;
              }
              if (self.smart_filter.privacy_teams) {
                user_filter.linked_teams = self.smart_filter.privacy_teams;
              }
              if (self.smart_filter.privacy_org_levels) {
                user_filter.linked_org_level = self.smart_filter.privacy_org_levels;
              }
              if (self.smart_filter.privacy_grades) {
                user_filter.linked_grade = self.smart_filter.privacy_grades;
              }
              if (self.smart_filter.groups) {
                user_filter.groups = self.smart_filter.groups;
              }
              if (self.smart_filter['$or']) {
                user_filter['$or'] = self.smart_filter['$or'];
              }
              self.searching = true;
              self.searchLoading = true;
              Users.find(user_filter).$promise.then(function(users) {
                var ids = users.map(function(user) {
                  self.userDirectory[user._id] = user;
                  return user._id;
                });

                self.filter.page = 1;
                self.filter.users = ids;
                if (!ids || !ids.length) {
                  self.loadItems(false, true);
                } else {
                  self.loadItems();
                }
              });
            },
            csv_filtered: '',
            csv_selected: ''
          };

          self.initialize();
        }],
      controllerAs: 'hostRegistrations'
    };
  }]);
